import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Modules from '@/store/modules'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: Modules,
    plugins: [
        new VuexPersistence({
            modules: [
                'user'
            ]
        }).plugin
    ]
})